import { render, staticRenderFns } from "./BackofficeMedicosCadastradosForm.vue?vue&type=template&id=4b950d10&scoped=true"
import script from "./BackofficeMedicosCadastradosForm.vue?vue&type=script&lang=ts"
export * from "./BackofficeMedicosCadastradosForm.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeMedicosCadastradosForm.vue?vue&type=style&index=0&id=4b950d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b950d10",
  null
  
)

export default component.exports